// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBzp-Eas36bWVkEoyxLTmk2Gn9in3wkYlA",
  authDomain: "tagandtrace-43338.firebaseapp.com",
  projectId: "tagandtrace-43338",
  storageBucket: "tagandtrace-43338.firebasestorage.app",
  messagingSenderId: "784946155830",
  appId: "1:784946155830:web:a293085246dfcda250a397",
  measurementId: "G-9XBJV8E0Y1"
};

// Initialize Firebase once at module level
let app;
let messagingInstance;

if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();
  messagingInstance = getMessaging(app);
}

class AltisFirebase {
  constructor() {
    this.messaging = messagingInstance;
  }

  async generateToken() {
    try {
      if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          try {
            const token = await getToken(this.messaging, {
              vapidKey: "BAZ_fh1jpb3bFh9LQBoBTda6IrTYPuR3kVxSIjL0SsekGujSbCVCCaEt8mzoJIOOwyX3oNo7SQ1FszRtCCih5Ms" 
            });
            return token;
          } catch (error) {
            console.error("Error getting token:", error);
          }
        }
      }
      return "";
    } catch (exception) {
      console.error(exception);
      return "";
    }
  }
}

export default AltisFirebase;
